<div *ngIf="!canLoad">
	<div class="auth-content">
		<app-value-proposition></app-value-proposition>
	</div>
	<div class="content-box form-wrapper">
		<div *ngIf="!linkResent">
			<h2 class="align-center section-heading" [translate]="'registration.create-password.link-expired.title'">
				Link Expired!
			</h2>
			<span [translate]="'registration.create-password.link-expired.expired'">Link expired or invalid.</span>
			<span
				class="link"
				(click)="resendVerificationCode()"
				[translate]="'registration.create-password.link-expired.click-here'"
				>Click here</span
			>
			<span [translate]="'registration.create-password.link-expired.resend-link'">to resend link.</span>
		</div>
		<ng-container *ngIf="linkResent">
			<div class="align-center mt-3">
				<h2 class="align-center section-heading" [translate]="'registration.create-account.check-email'">
					Check your email!
				</h2>
				<div class="align-center mt-3">
					<span [translate]="'registration.create-account.please-check'"
						>We have sent you an email to confirm your account. If you do not see the email in a few minutes, check your
						spam folder.</span
					>
				</div>
			</div>
			<div class="center mt-3">
				<button
					class="button button-medium mt-3"
					mat-button
					appEheAnalytics
					[routerLink]="['/login']"
					[data]="{
						pageUrl: '/registration',
						redirectedTo: '/login',
						componentName: 'create-account',
						id: 'Return to Sign In',
						placement: 'Registration - Back Button'
					}">
					<span [translate]="'registration.create-account.back-btn'">Back</span>
				</button>
			</div>
		</ng-container>
	</div>
</div>
<div class="content-box form-wrapper" *ngIf="canLoad">
	<div class="auth-content" *ngIf="!cognitoResponse?.success && !accountCreationFailed">
		<h2 class="align-center section-heading" [translate]="'registration.create-password.title'">Create Password</h2>
		<p class="align-center" [translate]="'registration.create-password.description'">
			For security, please create a password below.
		</p>
		<p class="align-center inline-error-message text-14" *ngIf="!cognitoResponse?.success">
			{{ cognitoResponse?.object?.message }}
		</p>
	</div>
	<div class="content-box-wrapper" *ngIf="!cognitoResponse?.success && !accountCreationFailed">
		<div [formGroup]="createPasswordForm" aria-autocomplete="none">
			<div class="row">
				<div class="col-12 password-wrapper">
					<mat-form-field class="form-group">
						<mat-label>{{ 'registration.create-password.form.create-password' | translate }}</mat-label>
						<input
							#password
							formControlName="password"
							matInput
							type="password"
							appShowHidePassword
							maxlength="32"
							(focusin)="hidePasswordStrengthBlock = false" />
					</mat-form-field>
					<div class="strength-wrapper {{ hidePasswordStrengthBlock ? 'hide' : '' }}">
						<mat-hint class="hint" align="end" aria-live="polite"> {{ password.value.length }} / 32 </mat-hint>
						<mat-password-strength
							#passwordComponent
							[password]="password.value"
							[enableLengthRule]="true"
							[enableSpecialCharRule]="false"
							[customValidator]="passwordSpecialCharsValidatorRegExp"></mat-password-strength>
						<password-strength-info
							[passwordComponent]="passwordComponent"
							digitsCriteriaMsg="{{ 'shared.password.digits-rule' | translate }}"
							upperCaseCriteriaMsg="{{ 'shared.password.uppercase-rule' | translate }}"
							lowerCaseCriteriaMsg="{{ 'shared.password.lowercase-rule' | translate }}"
							customCharsCriteriaMsg="{{ 'shared.password.special-character-rule' | translate }}">
						</password-strength-info>
					</div>
				</div>

				<div class="col-12 {{ !hidePasswordStrengthBlock ? 'pt-3' : 'pt-5' }}">
					<mat-form-field class="form-group top-spacing-on-small-device">
						<mat-label>{{ 'registration.create-password.form.confirm-password' | translate }}</mat-label>
						<input
							matInput
							type="password"
							formControlName="confirmPassword"
							appShowHidePassword
							maxlength="32"
							(focusin)="hidePasswordStrengthBlock = true" />
						<mat-error>
							<app-error-message [control]="'confirmPassword'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>
				<div *ngIf="getGlobalMfaStatus()" class="col-12 pt-3">
					<mat-label style="color: #0053a7">TWO-FACTOR SIGN IN</mat-label>
					<p style="font-size: 13px; padding-top: 5px">
						Two-factor sign in will be enabled to provide an additional layer of security for your myEHE account. You
						can manage your sign-in preferences on the My Account page on myEHE.
					</p>
				</div>
				<div class="col-12 {{ checkIfConfirmPasswordHasErrors() ? 'pt-4' : '' }}">
					<div class="center top-spacing-on-small-device">
						<button
							class="button button-medium"
							appEheAnalytics
							mat-button
							(click)="createCognitoAccount(); hidePasswordStrengthBlock = true">
							<span [translate]="'registration.create-password.form.submit-button'">COMPLETE ACCOUNT</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row justify-content-md-center" *ngIf="accountCreationFailed">
		<div class="col-md-10 failure-wrapper">
			<p class="link-text text-16" [translate]="'registration.create-password.registration-failure'"></p>
			<div>
				<p class="text-16">
					<span [translate]="'registration.create-password.error-message'"></span>
					<a class="link" href="mailto:MemberServices@ehe.health">
						<span [translate]="'registration.create-password.contact-email'">MemberServices&#64;ehe.health</span>
					</a>
				</p>
			</div>
			<div>
				<button
					class="button button-medium"
					mat-button
					appEheAnalytics
					[data]="{
						pageUrl: '/registration/verification/email',
						redirectedTo: '/registration',
						componentName: 'email-verification',
						id: 'Back to Registration',
						placement: 'Create Password'
					}"
					[routerLink]="['/registration']"
					[translate]="'registration.create-password.back-to-registration'">
					Back to Create My Account
				</button>
			</div>
		</div>
	</div>
</div>
